// Loader.tsx
import React from 'react'
import Lottie from 'react-lottie-player'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

import truckAnimation from '@/assets/images/delivery-truck.json'

const Loader: React.FC = () => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: theme.palette.black?.[20],
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1300, // Yüksek bir z-index değeri veriyoruz
      }}
    >
      <Lottie animationData={truckAnimation} loop play style={{ width: 150, height: 150 }} />
    </Box>
  )
}

export default Loader
